export const DATA_EXPORT_DATASETS = {
    CALLS: "calls",
    TRANSCRIPTS: "transcripts",
} as const;

export const DATA_EXPORT_DATASET_ORDER = [DATA_EXPORT_DATASETS.CALLS, DATA_EXPORT_DATASETS.TRANSCRIPTS] as const;

export const DATA_EXPORT_FILE_EXTENSION = "json.gz";
